export const ROOM_TYPE_CONSTS = {
    GET_ROOM_TYPES: "GET_ROOM_TYPES",
    CREATE_ROOM_TYPE: "CREATE_ROOM_TYPE",
    UPDATE_ROOM_TYPE: "UPDATE_ROOM_TYPE",
    DELETE_ROOM_TYPE_BY_ID: "DELETE_ROOM_TYPE_BY_ID",
};
